import React, {useEffect, useState} from "react";

// import redux
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../features/store";
import {getProjectList} from "../../features/sliceReducer/projectListReducer";

import {projectModalCloseAction} from "../../features/sliceReducer/interactionReducer";

//import component
import PaginationControlled from "../../components/PaginationControlled";

//import material-UI
import {makeStyles, createStyles, withStyles, Theme} from "@material-ui/core/styles";
import {
  Box,
  Button,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

import WorkIcon from "@material-ui/icons/Work";
import moment from "moment";
import Loading from "../../components/Loading";
import {getReferenceProject} from "../../features/sliceReducer/myProjectReducer";
import ListFilter from "../../components/ListFilter";
import {addCompareProjectAction} from "../../features/sliceReducer/projectReducer";

//material-UI-Style
const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      width: "1480px",
      minWidth: "1480px",
      height: "880px",
      overflowY: "auto",
      backgroundColor: theme.palette.background.default,
      border: `2px solid ${theme.palette.primary.main}`,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(3, 6, 3),
    },

    table: {
      // minWidth: 650,
      border: "1px solid #dbdce0",
      "& td": {
        borderBottom: "none",
      },
    },
    tableHead: {
      backgroundColor: theme.palette.gray.light,
    },
    buttonCell: {
      display: "flex",
      justifyContent: "space-around",
    },
    modalTitle: {
      marginBottom: " 30px",
      textAlign: "center",
      fontWeight: "bold",
    },
    searchInput: {
      display: "flex",
      justifyContent: "center",
      marginBottom: " 20px",
    },

    buttonStyle: {
      display: "flex",
      justifyContent: "center",

      "& button": {
        width: "200px",
        height: "40px",
        marginTop: "80px",
      },
    },
  })
);

const AddProjectModal = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [searchWord, setSearchWord] = useState<string>("");
  const [page, setPage] = useState<number>(1);

  const {projectList, loading, error, maxPage, filtering, switchChecked, addProjectTableHeader} =
    useSelector((state: RootState) => state.projectList);
  const {projectModalToggle} = useSelector((state: RootState) => state.interaction);

  const {userToken} = useSelector((state: RootState) => state.auth);

  const {addProjectSwitch} = useSelector((state: RootState) => state.project);

  const {region, year, grade} = filtering;

  useEffect(() => {
    dispatch(getProjectList({userToken, isAll: switchChecked, year, region, grade}));
  }, [switchChecked, year, region, grade]);

  const searchDispatcher = (page?: number, keyword?: string) => {
    if (page === undefined) page = 1;
    if (!keyword) {
      if (keyword !== "") keyword = sessionStorage.getItem("projectSearchWord")!;
    }
    if (keyword === undefined)
      dispatch(getProjectList({userToken, isAll: switchChecked, searchWord, page}));
    else
      dispatch(
        getProjectList({
          userToken,
          isAll: switchChecked,
          searchWord: keyword,
          page,
        })
      );
  };

  const getReferenceAsync = async (uid: number) => {
    await Promise.resolve(dispatch(getReferenceProject({userToken, id: uid})));
    dispatch(projectModalCloseAction());
  };

  const addCompareProject = (uid: number) => {
    dispatch(addCompareProjectAction(uid));
    dispatch(projectModalCloseAction());
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={projectModalToggle}
      onClose={() => {
        dispatch(projectModalCloseAction());
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={projectModalToggle}>
        <TableContainer component={Paper} className={classes.paper}>
          <Typography className={classes.modalTitle} variant="h5" component="h5">
            프로젝트 불러오기
          </Typography>
          <Box className={classes.searchInput}>
            <ListFilter
              setSearchWord={setSearchWord}
              searchDispatcher={searchDispatcher}
              page={page}
              searchWord={searchWord}
            />
          </Box>
          <Table className={classes.table} aria-label="simple table">
            <TableHead className={classes.tableHead}>
              <TableRow>
                {addProjectTableHeader.map((headerTitle, index) => (
                  <TableCell key={index} align="center">
                    {headerTitle}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {projectList?.map((project, index) => (
                <StyledTableRow key={project.uid}>
                  <TableCell align="center">{project.uid}</TableCell>
                  <TableCell align="center">{moment(project.startDate).format("YYYY년")}</TableCell>
                  <TableCell align="center">{project.factoryName}</TableCell>
                  <TableCell align="center">{project.name}</TableCell>
                  <TableCell align="center">{project.projectUserName}</TableCell>
                  <TableCell align="center">{project.participantsUsersName}</TableCell>
                  <TableCell className={classes.buttonCell}>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<WorkIcon />}
                      onClick={() => {
                        addProjectSwitch
                          ? getReferenceAsync(project.uid)
                          : addCompareProject(project.uid);
                      }}
                    >
                      추가
                    </Button>
                  </TableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
          <PaginationControlled
            page={page}
            maxPage={maxPage}
            pageChange={(page: number) => searchDispatcher(page, searchWord)}
          />
        </TableContainer>
      </Fade>
    </Modal>
  );
};

export default AddProjectModal;
